module.exports = __webpack_public_path__ + "img/undraw_qa_engineers.327b9b24.svg";